/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import Title from "../../extras/Title";
import Table from "../../extras/Table";
import { useEffect } from "react";
import { getAdmin } from "../../../redux/slice/authSlice";
import {
  getChart,
  getDashData,
  topSalons,
} from "../../../redux/slice/dashSlice";
import { useState } from "react";

import $ from "jquery";
import male from "../../../assets/images/male.png";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import dayjs from "dayjs";
import { upcomingBookings } from "../../../redux/slice/bookingSlice";
import Analytics from "../../extras/Analytics";
import { IconBuildingStore, IconCalendar, IconReceiptTax, IconUser, IconUserStar, IconWallet } from "@tabler/icons-react";
import LazyImage from "../../extras/ImageFallback";
const DashBoard = () => {
  const { salon, dashData } = useSelector((state) => state.dash);
  const { futureBooking } = useSelector((state) => state.booking);
  const { setting } = useSelector((state) => state.setting);

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [counts, setCounts] = useState([]);
  const navigate = useNavigate();
  const [nextBooking, setNextBooking] = useState([]);
  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");

  useEffect(() => {
    let payload = {
      startDate,
      endDate,
    };
    dispatch(topSalons(payload));
    dispatch(getDashData(payload));
    dispatch(upcomingBookings(1));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    setData(salon);
  }, [salon]);

  useEffect(() => {
    setCounts(dashData);
  }, [dashData]);

  useEffect(() => {
    setNextBooking(futureBooking);
  }, [futureBooking]);

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", male);
    });
  });

  const mapData = [
    {
      Header: "No",
      Cell: ({ index }) => <span>{index + 1}</span>,
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <LazyImage
            src={row && row.salonImage}
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            alt="salon"
            // className="cursor-pointer"
            height={`100%`}

          // onError={(e) => {
          //   e.target.src = Male;
          // }}
          />
        </div>
      ),
    },

    {
      Header: "Name",
      Cell: ({ row }) => <span>{row?.salonName}</span>,
    },

    {
      Header: `Salon Commission `,
      Cell: ({ row }) => (
        <span className="">
          {numberWithCommas(row?.salonCommission) + " " + setting?.currencySymbol}
        </span>
      ),
    },
    {
      Header: "Bookings",
      Cell: ({ row }) => <span className="">{row?.bookings}</span>,
    },
  ];

  const appointMentData = [
    {
      Header: "User",
      thClass: "text-nowrap",
      Cell: ({ row }) => (
        <div className="d-flex text-nowrap userProfile">
          <div>
            <LazyImage
              src={row?.userId?.image}
              alt=""
              className=""
              style={{ width: "50px", height: "50px" }}
            />
          </div>
          <span className="ms-3 fw-semibold fs-15 p8-top text-start">
            {row?.userId?.fname
              ? row?.userId?.fname + "  " + row?.userId?.lname
              : "Salon User"}
            <div
              className="fs-12  text-start"
              style={{ opacity: "0.65" }}
            >
              {row?.date?.split("T")[0]}
            </div>
          </span>
        </div>
      ),
    },
    {
      Header: "Salon",
      thClass: "text-nowrap",
      Cell: ({ row }) => <span className="text-nowrap">{row?.salonId?.name}</span>,
    },
    {
      Header: "Time",
      thClass: "text-nowrap",
      Cell: ({ row }) => <span className="text-nowrap">{row?.time[0]}</span>,
    },
    // {
    //   Header: "Show More",
    //   thClass: "text-decoration-underline special cursor",
    //   thClick: () => navigate("/admin/futureBooking"),
    //   Cell: ({ row }) => <></>,
    // },
  ];

  function numberWithCommas(number) {
    const formattedNumber = number?.toLocaleString("en-IN");
    return formattedNumber;
  }

  const CustomeCard = ({ link, title, count, Icon }) => {
    return (
      <div
        className="col-xl-3 col-sm-6 col-12 cursor-pointer"
        onClick={() => navigate(link)}
      >
        <div className="card">
          <div className="card-content cursor-pointer">
            <div className="card-body p-4">
              <div className="align-content-center d-flex justify-content-between media">
                <div className="media-body text-left">
                  <h3 className="warning">{count}</h3>
                  <span className="fw-medium">{title}</span>
                </div>
                <div className="align-self-center">
                  {<Icon className={"dashboard-card-icon"} />}
                </div>
              </div>
              <div className="progress mt-2 mb-0" style={{ height: 7 }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: "50%" }}
                  aria-valuenow={50}
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="dashboard " style={{ padding: "15px", marginTop: "0px" }}>
      <div className="dashboardHeader primeHeader !mb-0 !p-0">
        <div className="align-items-center d-flex justify-content-between">
          <div>
            <h4 className="heading-dashboard fw-semibold d-block">
              Welcome Admin !
            </h4>
            <h4 class="mb-0  text-capitalize text-nowrap" style={{ fontSize: 20, fontWeight: 500 }}>Dashboard</h4>
          </div>
          <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
            direction={"end"}
          />
        </div>

      </div>


      <div className="dashBoardMain px-4 mt-4">
        <div className="row dashboard-count-box">

          <CustomeCard
            link={"/admin/userTable"}
            title={"Total Customers"}
            count={counts?.users ? counts?.users : 0}
            Icon={IconUser}
          />
          
          <CustomeCard
            link={"/admin/bookingTable"}
            title={"Completed Booking "}
            count={counts?.bookings ? counts?.bookings : 0}
            Icon={IconCalendar}
          />

          <CustomeCard
            link={"/admin/allSalon"}
            title={"Total Salons"}
            count={counts?.salons ? counts?.salons : 0}
            Icon={IconBuildingStore}
          />

          <CustomeCard
            link={"/admin/allExperts"}
            title={"Total Expert"}
            count={counts?.experts ? counts?.experts : 0}
            Icon={IconUserStar}
          />
          <CustomeCard
            link={"/admin/staffEarning"}
            title={"Sales Commisions"}
            count={
              (counts?.commission ? counts?.commission?.toFixed(2) : 0) +
              (setting?.currencySymbol || "$")
            }
            Icon={IconReceiptTax}
          />

          <CustomeCard
            link={"/admin/monthlyReport"}
            title={"Total Revenue"}
            count={
              (counts?.revenue ? counts?.revenue?.toFixed(2) : 0) +
            (setting?.currencySymbol || "$") 
            }
            Icon={IconWallet}
          />


        </div>
      </div>

      <div className="dashboard-analytics px-4">

        <h6>Data Analytics</h6>
        <div className="">
          <ApexChart />
        </div>
      </div>



      <div className="px-4 mt-4">
        <div className="row">
          <div className=" mb-3 col-xl-6 col-12">
          <div className="border border-2 rounded-2 h-100">
            <div className="user-table-top">
              <div className=" d-flex justify-content-between align-items-center w-100 ">
                <div className="w-100">
                  <h5
                    className="main-title">
                    Top Salons
                  </h5>
                </div>

              </div>
            </div>
            <Table data={data} mapData={mapData} className="border-0" />
          </div>
          </div>
          <div className="  mb-3 col-xl-6 col-12 ">
          <div className="border border-2 rounded-2 h-100">

            <div className="user-table-top">
              <div className=" d-flex justify-content-between align-items-center w-100 ">
                <div className="w-100">
                  <h5
                    className="main-title">
                    Today's Upcoming Bookings
                  </h5>
                </div>
                <div className="w-100">
                  <p className="cursor-pointer mb-0 text-decoration-underline text-end" onClick={() => navigate("/admin/futureBooking")}>
                    See More
                  </p>
                </div>

              </div>
            </div>
            <Table data={nextBooking} mapData={appointMentData} className="border-0" />
          </div>
          </div>
        </div>
        {/* <div className="col-lg-6 col-md-12">
          <div className="m40-top tsBox p-3 br-2">
            <h5 className="text-center text-theme">
              TODAY'S UPCOMING BOOKINGS
            </h5>
            <Table
              data={nextBooking}
              mapData={appointMentData}
              className="border-0"
            />
          </div>
        </div> */}
      </div>

    </div>
  );
};
export default DashBoard;

const DashBox = ({ dashIcon, dashSVG, title, amount, onClick }) => {
  return (
    <div className="dashBox d-flex cursor" onClick={onClick}>
      <div className="dashIconBox midBox col-xl-4 col-md-5 col-6">
        <div className="dashIcon midBox">
          {dashIcon ? <i className={`${dashIcon}`}></i> : dashSVG}
        </div>
      </div>
      <div className="boxContent text-center col-xl-8 col-md-7 col-6">
        <div className="boxTitle midBox">
          <p className="text-decoration-underline">{title}</p>
        </div>
        <div className="boxAmount midBox mt-2">
          <p>{amount}</p>
        </div>
      </div>
    </div>
  );
};

const ApexChart = () => {
  const { chartData } = useSelector((state) => state.dash);
  const dispatch = useDispatch();
  var webSize = $(window).width();
  const resHeight =
    webSize >= 992 ? 500 : webSize < 992 && webSize > 576 ? 400 : 300;
  const [chart, setChart] = useState();

  useEffect(() => {
    const payload = { startDate: "ALL", endDate: "ALL" };
    dispatch(getChart(payload));
  }, []);

  useEffect(() => {
    setChart(chartData);
  }, [chartData]);

  let label = [];
  let data = [];
  let dataAmount = [];
  let dataCount = [];

  const total = chart;

  chart?.map((data_) => {
    const newDate = data_.date;
    var date;
    if (newDate._id) {
      data = dayjs(newDate?._id).format("DD MMM YYYY");
    } else {
      date = dayjs(newDate).format("DD MMM YYYY");
    }

    date?.length > 0 && label.push(date);
    dataAmount.push(parseInt(data_.revenue));
    dataCount.push(parseInt(data_.count));
  });


  const totalSeries = {
    labels: label,
    dataSet: [
      {
        name: "Total revenue",
        data: dataAmount,
      },
      {
        name: "Total count",
        data: dataCount,
      },
    ],
  };
  const optionsTotal = {
    chart: {
      type: "area",
      stacked: false,
      height: "200px",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      categories: label,
      rotate: 0,
      rotateAlways: true,
      minHeight: 50,
      maxHeight: 100,
      labels: {
        offsetX: -4, // Adjust the offset vertically
        fontSize: 10,
      },
    },
    tooltip: {
      shared: true,
    },

    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetX: -10,
    },
    colors: ["#259ACD", "#0f7085"],
  };

  return (
    <div id="chart" className="dashboard-user-count">
      <ReactApexChart
        options={optionsTotal}
        series={totalSeries.dataSet}
        type="area"
        height={resHeight}
      />
    </div>
  );
};
